import { Link } from "react-router-dom";

import image from "./../../assets/image-notFound.jpg";

import styles from "./styles.module.scss";

export function NotFound() {
  return (
    <main className={styles.notFound}>
      <Link to="/">
        <button>Voltar a página inicial </button>
      </Link>
      <img src={image} alt="" />
    </main>
  );
}
